import { useEffect, useRef, useState } from "react";
import "./Our_Products.css";

const ProductItem = ({ item }) => {
  const ref = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setActive(entry.isIntersecting);
      },
      {
        threshold: 0.5,
      },
    );

    if (ref.current) observer.observe(ref.current);

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);
  return (
    <div className={`product_block ${active ? "active" : "inactive"}`}>
      {/* DESCRIPTION CARD */}

      <div className="product_desc_card" ref={ref}>
        <div className="row">
          <div className="col-lg-2 col-md-2 col-sm-2">
            <div>
              <h2 className="section_number">{item.number}</h2>
            </div>
          </div>

          <div className="col-lg-10 col-md-10 col-sm-10">
            <p className="section_title">
              {item.title}
              <span> {item.subtitle}</span>
            </p>

            <p className="section_desc">{item.description}</p>

            <div className="product_features">
              <p className="key_features">Key Features :</p>
              {item.features.map((feature, index) => (
                <p key={index} className="features">
                  <img
                    src="/assets/images/home/our_products/airpods.png"
                    alt="airpods"
                    className="aripods_img"
                  />{" "}
                  {feature}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* IMAGE STACK */}
      <div className="product_image_wrapper">
        <img src={item.image} alt={item.title} />
      </div>
    </div>
  );
};

const Our_Products = () => {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  const productSections = [
    {
      id: 1,
      number: "01",
      title: "Calling Mobile Applications",
      subtitle: "Join. Listen. Speak. Connect.",
      description:
        "Users can join audio rooms, listen to live conversations, request to speak, interact with hosts & connect with the community in real time.",
      features: ["Call Mute / Unmute", "Speaker Mode", "Waiting Room"],
      image: "/assets/images/home/our_products/img-1.png",
    },

    {
      id: 2,
      number: "02",
      title: "Host App",
      subtitle: "Create rooms. Manage conversations. Lead the stage.",
      description:
        "Users can join audio rooms, listen to live conversations, request to speak, interact with hosts & connect with the community in real time.",
      features: ["Call Mute / Unmute", "Speaker Mode", "Waiting Room"],
      image: "/assets/images/home/our_products/img-2.png",
    },
    {
      id: 3,
      number: "03",
      title: "Web Host Access",
      subtitle: "Host from anywhere, on any device",
      description:
        "Users can join audio rooms, listen to live conversations, request to speak, interact with hosts & connect with the community in real time.",
      features: ["Call Mute / Unmute", "Speaker Mode", "Waiting Room"],
      image: "/assets/images/home/our_products/img-3.png",
    },
    {
      id: 4,
      number: "04",
      title: "Admin Panel",
      subtitle: "Full control of the entire platform",
      description:
        "The Admin Panel provides complete control over the platform through a single, centralized dashboard. Admins can efficiently manage users, hosts, rooms, and system activities while ensuring security and smooth operations.",
      features: ["Call Mute / Unmute", "Speaker Mode", "Waiting Room"],
      image: "/assets/images/home/our_products/img-4.png",
    },
  ];

  return (
    <section className="our_products">
      <div className="container">
        <div className="our_products_title_holder">
          <img
            src="/assets/images/home/our_products/product.png"
            alt="product-img"
            className="product_title"
          />
        </div>

        <div className="product_content_holder">
          {productSections.map((item) => (
            <ProductItem key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Our_Products;
